export const iconFontAwesomeCodingNetworkWired = (
	<i className="fa-solid fa-network-wired"></i>
);
